export const SITE_CONTACT = {
  email: 'hola@workhoops.com',
  privacyEmail: 'hola@workhoops.com',
  legalEmail: 'hola@workhoops.com',
  locationLabel: 'Matadepera, Barcelona, España',
  legalOwner: 'Eduardo Jimenez Ortega',
  legalTaxId: '47155163B',
  legalStatus: 'Empresario individual / autónomo',
  tradeName: 'WorkHoops',
  legalAddress: 'Carrer Llevant 23, 08230 Matadepera, Barcelona, España',
} as const
